import React, { useEffect, useState } from 'react';
import { ScrollingCarousel } from '@trendyol-js/react-carousel';
import { getPercent } from 'sdk/utils/assets';
import { Link } from 'react-router-dom';
import ContentSection from 'components/shared/ContentSection';
import useFollowingAssets from 'sdk/hooks/follow/useFollowingAssets';
import useUser from 'sdk/hooks/user/useProfile';
import CategoriesFilter from 'components/shared/CategoriesFilter';
import CategoriesSelect from 'components/shared/CategoriesSelect';
import styles from './TopAssets.module.scss';

function TopAssetsFollowing({
  showCategories, showCategoriesSelect,
  relativeActiveCategory,
} : {
  showCategories?: boolean,
  showCategoriesSelect?: boolean,
  relativeActiveCategory?: any,
}) {
  const { data: user } = useUser()
  const { data: itemsData } = useFollowingAssets(user?.id)
  const [activeCategory, setActiveCategory] = useState<number | string | null>(null)

  useEffect(() => {
    if (relativeActiveCategory) {
      setActiveCategory(relativeActiveCategory)
    } else {
      setActiveCategory(null)
    }
  }, [relativeActiveCategory])

  const items = (itemsData || [])
    .filter((item: any) => (
      !activeCategory || (+activeCategory === item.category_id)
    ))
    .filter((i) => i.active)

  // eslint-disable-next-line react/jsx-no-useless-fragment
  if ((!showCategoriesSelect && !items.length) || !itemsData?.length) return <></>

  return (
    <ContentSection
      title="Assets I'm following"
      headerRight={(
        <>
          {showCategories ? (
            <CategoriesFilter
              value={relativeActiveCategory || activeCategory || ''}
              onChange={setActiveCategory}
              disabledNfts
            />
          ) : null}
          {showCategoriesSelect ? (
            <CategoriesSelect
              onChange={setActiveCategory}
              disabledNfts
            />
          ) : null}
        </>
      )}
    >
      <ScrollingCarousel className={styles.picks}>
        {items.map((asset: any) => (
          <Link
            key={asset.id}
            className={styles.picksItem}
            to={`/asset/${asset.category?.name}/${asset.ticker}`}
            onMouseDown={(e) => e.preventDefault()}
          >
            <img src={asset?.icon} alt={asset?.ticker} />
            <span className={styles.picksItemChanges}>
              {`${getPercent(asset)}%`}
            </span>
          </Link>
        ))}
      </ScrollingCarousel>
    </ContentSection>
  )
}

export default TopAssetsFollowing
